import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { CampaignRoute, CampaignPathName } from '@/modules/ta/campaign/campaign.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${CampaignRoute.CAMPAIGNS}`,
      name: CampaignPathName.CAMPAIGNS,
      component: () => import(/* webpackChunkName: "campaigns-page" */ './pages/CampaignsPage.vue'),
    },
  ],
  Module.CAMPAIGN
);
